import { api } from "@/lib/api";
export const WS = "/creative/workspace";
export const studioError = e => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? d.map(x => x.msg).join("; ") : d?.message || e?.message || "Something went wrong. Your project is saved."; };
export const blankSound = () => ({mode:"auto",narration:"",model:"",voice:"",language:"English",effects:"",music_requested:false});
export const activeJob = j => ["authorizing","reconciling","queued","processing","running","polling","assembling","checking_status","awaiting_frames"].includes(j?.status);
export const creditsText = n => `${Number(n || 0).toLocaleString(undefined,{maximumFractionDigits:3})} ${Number(n) === 1 ? "credit" : "credits"}`;
export const directorSound = (sound, narration) => ({...sound, narration, mode:narration ? (["silent","native"].includes(sound.mode)?"auto":sound.mode) : sound.effects?.trim()?"custom":sound.mode==="native"?"native":"silent"});
export async function uploadStudioFile(projectId, file, onProgress = () => {}) {
  const cacheKey = `studio-upload:${projectId}:${file.name}:${file.size}:${file.lastModified}`;
  onProgress("Preparing file…");
  let session;
  try { session = JSON.parse(sessionStorage.getItem(cacheKey)); } catch { /* no saved session */ }
  if (!session) {
    session = (await api.post(`${WS}/projects/${projectId}/uploads`, {filename:file.name, content_type:file.type || "application/octet-stream", size:file.size})).data;
    sessionStorage.setItem(cacheKey, JSON.stringify(session));
  }
  for (let i = 0; i < session.chunk_count; i++) {
    onProgress(`Transferring part ${i + 1} of ${session.chunk_count}…`);
    await api.put(`${WS}/uploads/${session.asset_id}/parts/${i}`, file.slice(i * session.chunk_size, (i + 1) * session.chunk_size), {headers:{"Content-Type":"application/octet-stream"}, timeout:120000});
  }
  onProgress(/heic|heif/i.test(file.name) ? "Converting iPhone photo…" : "Preparing media for generation…");
  const {data} = await api.post(`${WS}/uploads/${session.asset_id}/complete`, {}, {timeout:120000});
  sessionStorage.removeItem(cacheKey);
  onProgress("Ready to use");
  return data;
}
